var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightLong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2797 8.52949C13.5727 8.23652 13.5727 7.76074 13.2797 7.46777L10.2797 4.46777C9.98672 4.1748 9.51094 4.1748 9.21797 4.46777C8.925 4.76074 8.925 5.23652 9.21797 5.52949L10.9383 7.2498H2.25C1.83516 7.2498 1.5 7.58496 1.5 7.9998C1.5 8.41465 1.83516 8.7498 2.25 8.7498H10.9383L9.21797 10.4701C8.925 10.7631 8.925 11.2389 9.21797 11.5318C9.51094 11.8248 9.98672 11.8248 10.2797 11.5318L13.2797 8.53184V8.52949Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightLong);
export default __webpack_public_path__ + "static/media/arrow-right-long.56788321c90235ef989c49c64ed37f76.svg";
export { ForwardRef as ReactComponent };